module.exports = __webpack_public_path__ + "img/free-kassa.9b6eb705.png";